// @flow

import styles from './MetaHierarchy.less';

import React, { Component } from 'react';
import {
  ScreenReaderOnly,
  Strong,
  ChevronIcon,
  Text
} from 'seek-style-guide/react';

type TypeStub = { [any]: any };
type MetaType = 'classification' | 'location';
type MetaShape = JobViewModelClassification | JobViewModelLocation;
type Props = {
  type: MetaType,
  meta: MetaShape,
  renderer?: any
};

const metaTypePrecendence = (type: MetaType) =>
  ({
    location: ['location', 'area'],
    classification: ['classification', 'subClassification']
  }[type]);

const generateMetaType = (meta: TypeStub) => type => ({
  [type]: meta[type] || null
});

const castMetaTypes = (meta: MetaShape, type: MetaType): Array<TypeStub> =>
  type === 'location' && meta.suburb
    ? [{ suburb: meta.suburb }]
    : metaTypePrecendence(type).map(generateMetaType(meta));

export default class MetaHierarchy extends Component<Props> {
  props: Props;

  renderItem = (item: TypeStub = {}, isChild?: boolean) => {
    const { renderer: Renderer } = this.props;
    const [label] = Object.keys(item);
    const metaItemOrNull: JobViewModelItemPartial | null = item[label] || null;

    if (metaItemOrNull === null) {
      return null;
    }

    return (
      <span>
        {isChild ? (
          <ChevronIcon
            small
            direction="right"
            className={styles.chevron}
            svgClassName={styles.chevronSvg}
          />
        ) : null}
        {label ? (
          <ScreenReaderOnly>{`${label}: ${
            metaItemOrNull.name
          }`}</ScreenReaderOnly>
        ) : null}
        {Renderer ? (
          <Renderer item={metaItemOrNull} type={label} />
        ) : (
          metaItemOrNull.name
        )}
      </span>
    );
  };

  render() {
    const { meta, type } = this.props;
    const [parent, child] = castMetaTypes(meta, type);

    return (
      <Text small>
        <Strong>{this.renderItem(parent)}</Strong>
        {this.renderItem(child, true)}
      </Text>
    );
  }
}
